import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import { HTMLContent } from '../components/Content';
import PageTitle from '../components/PageTitle';
import { AboutDesc, AboutImg, Gallery, AboutText } from '../components/about/StyledAboutPage';
import SEIKO_CLOCK from '../../src/img/carboot.jpg';
import GatsbyImage from "gatsby-image";

const GalleryAbout = ({ gallery }) => {
    return (
        <>
            <PageTitle>Gallery</PageTitle>
            <Gallery>
                {gallery !== undefined ? gallery.map(img => (
                    <GatsbyImage
                        alt={"gallery"}
                        image={img.childImageSharp.gatsbyImageData} />
                ))
                    : <h4>Stay in touch! Our admin is lazy ... images are already being uploaded :)</h4>}
            </Gallery>
        </>
    );
};


const AboutPage = ({ data }) => {
    const section = { marginTop: '5vh' };
    const { markdownRemark: post } = data;
    return (
        <Layout>
            <AboutDesc>
                <AboutText>
                    <h1>{post.frontmatter.title}</h1>
                    <HTMLContent content={post.html} />
                </AboutText>
                <AboutImg src={SEIKO_CLOCK} />
            </AboutDesc>
            <GalleryAbout style={section} gallery={post.frontmatter.gallery} />
        </Layout>
    );
};

AboutPage.propTypes = {
    data: PropTypes.object.isRequired,
};

export default AboutPage

export const aboutPageQuery = graphql`
    query AboutPage($id: String!) {
        markdownRemark(id: { eq: $id }) {
            html
            frontmatter {
                title
                gallery {
                    id
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                }
            }
        }
    }
`;
